import { css } from '@linaria/core';

export const image = css`
	overflow: hidden;
`;

export const blurredImage = css`
	filter: blur(8px);
`;
